/* S1 追加挙動 ＋ ABOUT US / SECRET でヘッダーを隠す */
(function () {
  'use strict';
  if (window.__mxExtraLoaded) return;
  window.__mxExtraLoaded = true;

  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  function heroDefault(sec) {
    var hero = sec.querySelector('.mx-hero');
    if (!hero) return;
    var key = isMobile() ? 'default-sp' : 'default';
    var imgs = hero.querySelectorAll('img');
    var found = false;
    imgs.forEach(function (i) { if (i.getAttribute('data-key') === key) found = true; });
    if (!found) key = 'default';
    imgs.forEach(function (i) { i.classList.toggle('is-on', i.getAttribute('data-key') === key); });
  }

  function deselect(sec) {
    var card = sec.querySelector('.mx-card.is-active');
    if (!card) return;
    card.classList.remove('is-active');
    card.style.background = '';
    card.style.borderColor = '';
    var nm = card.querySelector('.mx-name');
    if (nm) { nm.style.background = ''; nm.style.color = ''; }
    sec.classList.remove('is-selected');
    heroDefault(sec);
    var nb = sec.querySelector('.mx-namebar'); if (nb) nb.classList.remove('is-on');
    var db = sec.querySelector('.mx-detail-btn'); if (db) db.classList.remove('is-on');
  }

  function initSelectExtra(sec) {
    if (sec.dataset.mxExtra === '1') return;
    sec.dataset.mxExtra = '1';

    /* モバイルは3体表示なので、1つ送って真ん中をPCと揃える */
    var rail = sec.querySelector('.mx-rail');
    if (rail && isMobile() && rail.children.length >= 4) {
      rail.appendChild(rail.children[0]);
    }

    if (!sec.querySelector('.mx-scroll')) {
      var hint = document.createElement('div');
      hint.className = 'mx-scroll';
      hint.innerHTML = 'SCROLL<i>▼</i>';
      sec.appendChild(hint);
    }
    var hint2 = sec.querySelector('.mx-scroll');
    var ticking = false;
    function upd() {
      ticking = false;
      hint2.classList.toggle('is-hidden', window.scrollY > 20);
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(upd);
    }, { passive: true });
    upd();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.mx-card') || t.closest('.mx-arrow') || t.closest('.mx-detail-btn') || t.closest('.mx-modal')) return;
      deselect(sec);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (!en.isIntersecting) deselect(sec); });
      }, { threshold: 0.15 });
      io.observe(sec);
    }
  }

  function initHeaderHide() {
    var hdr = document.querySelector('.mhx-header');
    if (!hdr) return;
    var wrap = hdr.closest('.shopify-section') || hdr;
    var targets = document.querySelectorAll('.mx-sec--about, .mx-sec--secret');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    var shown = new Set();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) shown.add(en.target);
        else shown.delete(en.target);
      });
      wrap.classList.toggle('mx-head-off', shown.size > 0);
    }, { threshold: 0.25 });
    targets.forEach(function (t) { io.observe(t); });
  }

  function boot() {
    document.querySelectorAll('.mx-sec--select').forEach(initSelectExtra);
    initHeaderHide();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
